import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	stakeholdersTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.stakeholders-field.stakeholders-title',
		defaultMessage: 'Stakeholder communications',
		description:
			'The subtitle heading for the Stakeholders section of the new incident management settings info card',
	},
	stakeholdersDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.stakeholders-field.stakeholders-description',
		defaultMessage:
			'Keep your internal stakeholders informed by sending them emails about the incident’s status.',
		description:
			'The body text for the Stakeholders section of the incident management settings info card.',
	},
	stakeholdersLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.stakeholders-field.stakeholders-learn-more-link',
		defaultMessage: 'Learn how to add and manage internal stakeholders.',
		description:
			'The learn more text for Stakeholders section of the incident management settings info card.',
	},
});
